import { SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";

/**
 * TipsPanelHeader — hairline panel header with iris-accented icon tile,
 * General Sans 500 title, General Sans 400 description, mono badge.
 */
export function TipsPanelHeader({
  icon: Icon,
  title,
  description,
  badge,
}: {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description: string;
  badge: string;
}) {
  return (
    <SheetHeader className="px-5 pt-5 pb-4 border-b border-border bg-card text-left">
      <div className="flex items-start gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-border bg-muted">
          <Icon className="h-4 w-4 text-accent" />
        </div>
        <div className="flex-1 min-w-0">
          <SheetTitle className="font-sans text-[15px] font-medium text-foreground">
            {title}
          </SheetTitle>
          <SheetDescription className="font-sans text-[13px] font-normal text-muted-foreground mt-0.5">
            {description}
          </SheetDescription>
          <span className="mt-2 inline-flex items-center rounded-md border border-border bg-muted px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wide text-muted-foreground">
            {badge}
          </span>
        </div>
      </div>
    </SheetHeader>
  );
}
